<template>
  <b-row class="row-card-container px-0 mb-1 mb-md-2" v-if="data">
    <b-col cols="12" lg="8">
      <div
        class="d-flex flex-column flex-md-row flex-wrap drip-h4 color-noble-blue-500 font-weight-700 mb-1"
      >
        <slot name="title"></slot>
      </div>
      <slot name="subtitle"></slot>
      <div class="d-flex drip-body-small color-noble-blue-500 font-weight-700">
        <slot name="body"></slot>
      </div>
    </b-col>
    <b-col
      cols="12"
      lg="4"
      class="d-flex align-items-center justify-content-start justify-content-lg-end"
    >
      <action-button
        :data-id="data.id"
        variant="text"
        class="drip-body px-3"
        :click="() => redirectTo(data)"
      >
        <slot name="buttonBody">
          {{ buttonText }}
          <b-icon-chevron-right scale="0.9" class="ml-2" />
        </slot>
      </action-button>
    </b-col>
  </b-row>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'
import { ACTIONS, ENTITIES } from '@/utils/constants'

export default {
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  components: {
    ActionButton
  },
  props: ['data', 'buttonText', 'redirectTo'],
  methods: {
    hasPermissionToUpdate() {
      return this.$store.getters.hasActionPermission(
        ENTITIES.BANK,
        ACTIONS.CREATE
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.row-card-container {
  padding: 24px;
  @media screen and (max-width: 768px) {
    padding: 24px 16px;
    padding-bottom: 12px;
  }
  border: 1px solid $sky-blue-400;
  border-radius: 8px;
  .bank-status {
    &.Verified {
      border: 1px solid $spring-green-400;
      background: $spring-green-50;
      color: $noble-blue-500;
    }
    &.Pending {
      border: 1px solid $mustard-yellow-400;
      background: $mustard-yellow-50;
      color: $noble-blue-500;
    }
  }
}
</style>
